export default __webpack_public_path__ + "static/media/Blog.961809c6.pdf";